import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { ProperWordingComponent } from './proper-wording.component';


const routes: Routes = [
  {
    path: 'proper-wording',
    component: ProperWordingComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class ProperWordingRoutingModule {}
